import type { MouseEvent } from 'react'
import type { RecommendationItem } from '../index.h'

import { CardAnimations, CardType } from "/app/libraries/arcana/src/blocks/Cards/index.ts"
import { TextBoxTypes } from "/app/libraries/arcana/src/atoms/TextBox/index.ts"
import { VodSimpleCard } from "/app/libraries/arcana/src/blocks/Cards/Templates/index.ts"

import { useUnit } from 'effector-react'
import * as pinLockFeature from '~/features/pin-lock'
import { VodCardHorizontalCoversMap } from '~/shared/ui/components/cardCovers'

type RecommendationCardProps = {
  item: RecommendationItem
  onClick: (event: MouseEvent) => void
}

export function RecommendationCard({ item, onClick }: RecommendationCardProps) {
  const isLocked = useUnit(pinLockFeature.$isLockedFn)

  if (item.contentType !== 'vod' && item.contentType !== 'show') {
    return null
  }

  return (
    <VodSimpleCard
      type={CardType.HORIZONTAL}
      title={item.name}
      titleFont={TextBoxTypes.FontSmBold}
      posterUrl={item.posterUrl}
      covers={VodCardHorizontalCoversMap}
      childrenTransition={CardAnimations.FadeIn}
      lazyImage={false}
      onClick={onClick}
      paid={item.paid}
      rented={item.rented}
      locked={isLocked({ id: item.id, locked: item.locked })}
      aclBlockedBy={Boolean(item.blockedByAcl)}
      purchaseTitle={item.labelPrice}
      verticalVideo={item.vertical}
    />
  )
}
